import React from 'react';
import { DialogContentText, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Typography, createStyles, makeStyles } from '@material-ui/core';

import { StilingueSpreadsheetModel } from '../../../Models/StilingueSpreadsheetModel';
import { BasicDialog } from '../../../shared/components/BasicDialog';

interface IStilingueSpreadsheetConfigurationModalProps {
    isModalOpen: boolean,
    setIsModalOpen: (open: boolean) => void,
    stilingueSpreadsheet: StilingueSpreadsheetModel
}

export const useStyles = makeStyles(() => createStyles({
    infoText: {
        paddingTop: '16px',
        paddingBottom: '16px'
    }
}));

export function StilingueSpreadsheetConfigurationModal({
    isModalOpen,
    setIsModalOpen,
    stilingueSpreadsheet }: IStilingueSpreadsheetConfigurationModalProps) {

    const classes = useStyles();

    const getConfigurationTable = () => {
        return (
            <>
                <DialogContentText>
                    <TableContainer>
                        <Paper elevation={0}>
                            <Table
                                size="small"
                                aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Dado</TableCell>
                                        <TableCell align="center">Coluna</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {stilingueSpreadsheet.configurations.map((config) => (
                                        <TableRow key={config.id}>
                                            <TableCell component="th" scope="row">
                                                {config.columnDescription}
                                            </TableCell>
                                            <TableCell align="center">
                                                {config.column}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </TableContainer>
                </DialogContentText>
                <DialogContentText>
                    <Typography
                        variant="body2"
                        className={classes.infoText}>
                        * A primeira linha de dados deverá ser a linha 1, obrigatoriamente.
                    </Typography>
                </DialogContentText>
            </>
        );
    };


    return (
        <BasicDialog
            open={isModalOpen}
            handleClose={() => setIsModalOpen(false)}
            title={stilingueSpreadsheet.description}
            description="A relação de campos da planilha a ser inserida na plataforma deve seguir o padrão mostrado abaixo."
            children={ getConfigurationTable() } />
    );
}